import { inject } from "@angular/core";
import { PasswordPolicyResponse } from "@core/models/api.response";
import { PasswordPolicyService } from "@core/services/password-policy.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { passwordActions } from "./actions";

export const passwordPolicyEffect = createEffect(
  (
    actions$ = inject(Actions),
    passwordPolicyService = inject(PasswordPolicyService)
  ) => {
    return actions$.pipe(
      ofType(passwordActions.setPasswordPolicy),
      switchMap(() => {
        return passwordPolicyService.getPasswordPolicy().pipe(
          map((response: PasswordPolicyResponse) => {
            if (response != null) {
              return passwordActions.setPasswordPolicySuccess({
                passwordPolicy: response,
              });
            }
            return passwordActions.setPasswordPolicyFail();
          }),
          catchError(() => of(passwordActions.setPasswordPolicyFail()))
        );
      })
    );
  },
  { functional: true }
);
